module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wISEAkzruB21wAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAd0lEQVQY04WOQQ3CQBAA5wgGaqEWzgJaagELRUKxAlawABKGR5dAN9swyeWSvbnsNJWCAXjl4aEQF+AWH7aov2dx5amO6Y09sWdRpUXzDJxj2aXqBWjqADzKxp3mHutVpyohN3e/TP9kQvpwyvIxVV3j7sA9J78B7mnB5ogpDMYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/day/l.png
// module id = 512ce032d751e5e5c855
// module chunks = 13